module.exports = __webpack_public_path__ + "static/media/gear.c049810a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gear.svg
// module id = 27
// module chunks = 0